import { useLogisticaConfiguration, withLogisticaConfiguration } from "./configurazione/LogisticaConfigurationProvider";
import React, { useState, useEffect, useRef } from "react";
import DBperAreaOrdini from "./AreaOrdiniComponenti/DBperAreaOrdini";
import DBperAreaArticoliOrdini from "./AreaOrdiniComponenti/DBperAreaArticoliOrdini";
import DBperAreaContabili from "./AreaOrdiniComponenti/DBperAreaContabili";
import axios from "axios";
import DBperAreaVisteSpeciali from "./AreaOrdiniComponenti/DBperAreaVisteSpeciali";
import { serializzaRicercaOrdini } from "./AreaOrdiniComponenti/selezioneRicercaOrdini";


function AreaOrdiniNOORDINE({
  utente,
  ordine,
  setOrdine,
  ricercaIniz,
  tema,
  urlRicerca,
  setUrlRicerca,
  perPage,
  setPerPage,
  page,
  setPage,
  totalRows,
  setTotalRows,
  vista,
  columnSort,
  setColumnSort,
  directionSort,
  setDirectionSort,
  inputVuoto,
  urlParametri,
  setUrlParametri,
  ricerca,
  setRicerca,
  inputIniziale,
  setInputIniziale,
  colonna,
  mobile,
  perPageOptions,
  setVista,
  urlRicercaINIT,
  setGaranzia,
  setNuovaGaranzia,
  listaOrdiniDaAltrove,
  setListeOrdiniDaAltrove,
  funzioneScegliID,
  setVistaConReset,
  setListaId,
}) {
  const { datiTendineOrdine, selezioneCampiRicerca } = useLogisticaConfiguration();

  const [resImport, setResImport] = useState("");
  const [righeSelezionate, setRigheSelezionate] = useState([]);
  const [data, setData] = useState([]);
  const [filtroVeloce, setFiltroVeloce] = useState("");
  const [loading, setLoading] = useState(false);
  const [deseleziona, setDeseleziona] = useState(false);
  const tableRequestRef = useRef(null);

  useEffect(() => {
    if (listaOrdiniDaAltrove) {
      tableRequestRef.current?.abort();
      tableRequestRef.current = null;
      setLoading(false);
      setData(listaOrdiniDaAltrove);
    }
  }, [listaOrdiniDaAltrove]);

  useEffect(
    () => () => {
      tableRequestRef.current?.abort();
      tableRequestRef.current = null;
    },
    []
  );

  const fetchOrdini = async (pagina, urlArg, overrides = {}) => {
    const baseUrl = urlArg || urlRicerca || urlRicercaINIT;
    if (!baseUrl) {
      return false;
    }

    tableRequestRef.current?.abort();
    const controller = new AbortController();
    tableRequestRef.current = controller;

    const ricercaRichiesta = overrides.ricerca ?? ricerca;
    const vistaRichiesta = overrides.vista ?? vista;
    const ricercaConVista =
      vistaRichiesta === "note"
        ? { ...ricercaRichiesta, includeNote: "1" }
        : ricercaRichiesta;
    const perPageRichiesto = overrides.perPage ?? perPage;
    const columnSortRichiesto = overrides.columnSort ?? columnSort;
    const directionSortRichiesto = overrides.directionSort ?? directionSort;
    const nuoviParams = new URLSearchParams({
      ...serializzaRicercaOrdini(ricercaConVista),
      columnSort: columnSortRichiesto || "",
      directionSort: directionSortRichiesto || "",
    });
    const urlFinale =
      baseUrl + pagina + "/" + perPageRichiesto + "?" + nuoviParams;

    setPage(pagina);
    setLoading(true);
    try {
      const response = await axios.get(urlFinale, {
        headers: overrides.headers,
        signal: controller.signal,
      });
      if (
        controller.signal.aborted ||
        tableRequestRef.current !== controller
      ) {
        return false;
      }
      setData(response.data.data);
      setListaId(response.data.listaIdSped);
      setTotalRows(response.data.total);
      return true;
    } catch (error) {
      if (!controller.signal.aborted && !axios.isCancel(error)) {
        console.error("Errore nel caricamento dbOrdini", error);
      }
      return false;
    } finally {
      if (tableRequestRef.current === controller) {
        tableRequestRef.current = null;
        setLoading(false);
      }
    }
  };

  const handlePageChange = (pagina) => {
    setPage(pagina);
    fetchOrdini(pagina);
  };

  const handlePerRowsChange = async (newPerpagina, pagina) => {
    setPerPage(newPerpagina);
    fetchOrdini(pagina, undefined, { perPage: newPerpagina });
  };

  const handleSort = async (column, sortDirection) => {
    setPage(1);
    setColumnSort(column.sortField);
    setDirectionSort(sortDirection);
    fetchOrdini(1, undefined, {
      columnSort: column.sortField,
      directionSort: sortDirection,
    });
  };

  let listaFiltrata;

  if (filtroVeloce && filtroVeloce.length > 4) {
    listaFiltrata = data.filter(
      (item) =>
        item["N_rif_PrestaShop"] &&
        item["N_rif_PrestaShop"].includes(filtroVeloce.toString())
    );
  }

  return (
    <div className="fl w-100 w-100-ns">
      {(!vista || vista === "ordini" || vista === "evasione" || vista === "note") && (
        <div className="sfondoBiancoTema">
          <DBperAreaOrdini
            setOrdineFunction={setOrdine}
            urlRicerca={urlRicerca}
            setUrlRicerca={setUrlRicerca}
            setResImport={setResImport}
            resImport={resImport}
            totalRows={totalRows}
            setTotalRows={setTotalRows}
            perPage={perPage}
            setPerPage={setPerPage}
            page={page}
            setPage={setPage}
            urlParametri={urlParametri}
            setUrlParametri={setUrlParametri}
            datiTendineOrdine={datiTendineOrdine}
            ricerca={ricerca}
            tema={tema}
            utente={utente}
            vista={vista}
            selezioneCampiRicerca={selezioneCampiRicerca}
            inputIniziale={inputIniziale}
            setInputIniziale={setInputIniziale}
            columnSort={columnSort}
            directionSort={directionSort}
            fetchOrdini={fetchOrdini}
            handlePageChange={handlePageChange}
            handlePerRowsChange={handlePerRowsChange}
            handleSort={handleSort}
            setRigheSelezionate={setRigheSelezionate}
            righeSelezionate={righeSelezionate}
            data={listaFiltrata ? listaFiltrata : data}
            loading={loading}
            deseleziona={deseleziona}
            setDeseleziona={setDeseleziona}
            setData={setData}
            setRicerca={setRicerca}
            inputVuoto={inputVuoto}
            mobile={mobile}
            perPageOptions={perPageOptions}
            setVista={setVista}
            setLoading={setLoading}
            setListeOrdiniDaAltrove={setListeOrdiniDaAltrove}
            setVistaConReset={setVistaConReset}
            filtroVeloce={filtroVeloce}
            setFiltroVeloce={setFiltroVeloce}
          />
        </div>
      )}
      {vista === "articoli" && (
        <div className="sfondoBiancoTema">
          <DBperAreaArticoliOrdini
            ordine={ordine}
            setOrdineFunction={setOrdine}
            urlRicerca={urlRicerca}
            setUrlRicerca={setUrlRicerca}
            setResImport={setResImport}
            resImport={resImport}
            totalRows={totalRows}
            setTotalRows={setTotalRows}
            perPage={perPage}
            setPerPage={setPerPage}
            page={page}
            setPage={setPage}
            urlParametri={urlParametri}
            setUrlParametri={setUrlParametri}
            datiTendineOrdine={datiTendineOrdine}
            ricerca={ricerca}
            tema={tema}
            utente={utente}
            vista={vista}
            selezioneCampiRicerca={selezioneCampiRicerca}
            inputIniziale={inputIniziale}
            setInputIniziale={setInputIniziale}
            columnSort={columnSort}
            setColumnSort={setColumnSort}
            directionSort={directionSort}
            setDirectionSort={setDirectionSort}
            fetchOrdini={fetchOrdini}
            handlePageChange={handlePageChange}
            handlePerRowsChange={handlePerRowsChange}
            handleSort={handleSort}
            setRigheSelezionate={setRigheSelezionate}
            righeSelezionate={righeSelezionate}
            data={data}
            loading={loading}
            deseleziona={deseleziona}
            setDeseleziona={setDeseleziona}
            setData={setData}
            setRicerca={setRicerca}
            inputVuoto={inputVuoto}
            mobile={mobile}
            perPageOptions={perPageOptions}
            setVista={setVista}
            setLoading={setLoading}
            setListeOrdiniDaAltrove={setListeOrdiniDaAltrove}
            setVistaConReset={setVistaConReset}
          />
        </div>
      )}
      {(vista === "contabili" || vista === "contabiliRimborsi") && (
        <div className="sfondoBiancoTema">
          <DBperAreaContabili
            ordine={ordine}
            setOrdineFunction={setOrdine}
            urlRicerca={urlRicerca}
            setUrlRicerca={setUrlRicerca}
            setResImport={setResImport}
            resImport={resImport}
            totalRows={totalRows}
            setTotalRows={setTotalRows}
            perPage={perPage}
            setPerPage={setPerPage}
            page={page}
            setPage={setPage}
            urlParametri={urlParametri}
            setUrlParametri={setUrlParametri}
            datiTendineOrdine={datiTendineOrdine}
            ricerca={ricerca}
            tema={tema}
            utente={utente}
            vista={vista}
            selezioneCampiRicerca={selezioneCampiRicerca}
            inputIniziale={inputIniziale}
            setInputIniziale={setInputIniziale}
            columnSort={columnSort}
            setColumnSort={setColumnSort}
            directionSort={directionSort}
            setDirectionSort={setDirectionSort}
            fetchOrdini={fetchOrdini}
            handlePageChange={handlePageChange}
            handlePerRowsChange={handlePerRowsChange}
            handleSort={handleSort}
            setRigheSelezionate={setRigheSelezionate}
            righeSelezionate={righeSelezionate}
            data={data}
            loading={loading}
            deseleziona={deseleziona}
            setDeseleziona={setDeseleziona}
            setData={setData}
            setRicerca={setRicerca}
            inputVuoto={inputVuoto}
            mobile={mobile}
            perPageOptions={perPageOptions}
            setVista={setVista}
            setLoading={setLoading}
            setListeOrdiniDaAltrove={setListeOrdiniDaAltrove}
            setVistaConReset={setVistaConReset}
          />
        </div>
      )}
      {(vista === "checkSparati" ||
        vista === "attese" ||
        vista === "garanzie" ||
        vista === "anteprimaOrdiniGaranzie") && (
        <div className="sfondoBiancoTema">
          <DBperAreaVisteSpeciali
            ordine={ordine}
            setOrdineFunction={setOrdine}
            urlRicerca={urlRicerca}
            setUrlRicerca={setUrlRicerca}
            setResImport={setResImport}
            resImport={resImport}
            totalRows={totalRows}
            setTotalRows={setTotalRows}
            perPage={perPage}
            setPerPage={setPerPage}
            page={page}
            setPage={setPage}
            urlParametri={urlParametri}
            setUrlParametri={setUrlParametri}
            datiTendineOrdine={datiTendineOrdine}
            ricerca={ricerca}
            tema={tema}
            utente={utente}
            vista={vista}
            selezioneCampiRicerca={selezioneCampiRicerca}
            inputIniziale={inputIniziale}
            setInputIniziale={setInputIniziale}
            columnSort={columnSort}
            setColumnSort={setColumnSort}
            directionSort={directionSort}
            setDirectionSort={setDirectionSort}
            fetchOrdini={fetchOrdini}
            handlePageChange={handlePageChange}
            handlePerRowsChange={handlePerRowsChange}
            handleSort={handleSort}
            setRigheSelezionate={setRigheSelezionate}
            righeSelezionate={righeSelezionate}
            data={data}
            loading={loading}
            deseleziona={deseleziona}
            setDeseleziona={setDeseleziona}
            setData={setData}
            setRicerca={setRicerca}
            inputVuoto={inputVuoto}
            colonna={colonna}
            mobile={mobile}
            perPageOptions={perPageOptions}
            setVista={setVista}
            setLoading={setLoading}
            setGaranzia={setGaranzia}
            setNuovaGaranzia={setNuovaGaranzia}
            setListeOrdiniDaAltrove={setListeOrdiniDaAltrove}
            funzioneScegliID={funzioneScegliID}
            setVistaConReset={setVistaConReset}
          />
        </div>
      )}
    </div>
  );
}

export default withLogisticaConfiguration(AreaOrdiniNOORDINE);
